// src/components/molecules/UserProfile/Edit/UserNameInput.js

import React from "react";

const UserNameInput = ({ theme, userName, handleChange, disabled, maxLength = 20 }) => {
  return (
    <input
      type="text"
      name="userName"
      value={userName}
      onChange={handleChange}
      disabled={disabled}
      maxLength={maxLength}
      autoCapitalize="none"
      autoCorrect="off"
      spellCheck={false}
      inputMode="text"
      style={{
        width: "100%",
        backgroundColor: disabled ? theme.colors.mediumPurple : "#868A9C",
        color: "white",
        padding: "10px",
        border: "none",
        borderRadius: "4px",
        fontFamily: "basic-sans",
        outline: "none",
      }}
    />
  );
};

export default UserNameInput;
